<div class="pwa-install-banner" *ngIf="shouldBannerAppear && showBanner">
  <div class="pwa-install-banner_element d-flex align-items-center" (click)="onClickBanner()">
    <div class="mr-2">
      <img src="assets/icons/favicon-32x32.png" width="32">
    </div>
    <div class="mr-2">
      <span class="mr-1">{{'SI_PWA_INSTALL_BANNER_TITLE' | translate}}</span>
      <span class="pwa-install-banner_element_link">{{'SI_CLICK_HERE' | translate}}</span>
    </div>
    <div>
      <i class="icosun-close pwa-install-banner_element_close-icon" (click)="onClickCloseIcon()"></i>
    </div>
  </div>
</div>
